export default [
    [   
        {
            oldPath: "/blogs/85/por-mejor-construir-bloques-hormigon",
            newPath: "/tensonews",
            id:1,
          },
          {
            oldPath: "/blogs/87/nueva-linea-bloques-livianos",
            newPath: "/noticias/nueva-línea-de-bloques-livianos",
            id:2
          },
          {
            oldPath: "/blogs/106/cuanto-pesa-vigueta",
            newPath: "/noticias/¿cuánto-pesa-una-vigueta?",
            id:3
          },
          {
            oldPath: "/blogs/98/capas-compresion",
            newPath: "/noticias/capas-de-compresión-",
            id:4
          },
          {
            oldPath: "/blogs/93/cuales-son-luces-maximas-para-construir-viguetas-t21",
            newPath: "/tensonews",
            id:5
          },
          {
            oldPath: "/blogs/105/cual-diferencia-entre-viga-vigueta",
            newPath: "/tensonews",
            id:6
          },
          {
            oldPath: "/blogs/102/como-apuntalar-viguetas-correctamente",
            newPath: "/noticias/¿cómo-apuntalar-las-viguetas-correctamente?",
            id:7
          },
          {
            oldPath: "/blogs/86/viguetas-bovedillas-mejor-forma-trabajar-juntos",
            newPath: "/noticias/viguetas-y-bovedillas:-la-mejor-forma-de-trabajar-juntos",
            id:8
          },
          {
            oldPath: "/blogs/109/cmo-construir-losas-de-viguetas-en-zonas-ssmicas",
            newPath: "/noticias/cómo-construir-losas-de-viguetas-en-zonas-sísmicas",
            id:9
          },
          {
            oldPath: "/blogs/88/conoce-todo-sobre-nuestros-tensoblocks-livianos",
            newPath: "/noticias/conocé-todo-sobre-nuestros-tensoblocks-livianos",
            id:10
          },
          {
            oldPath: "/blogs/111/bovedillas-para-losas-viguetas-pretensadas-por-vienen-distintas-alturas",
            newPath: "/noticias/bovedillas-para-losas-de-viguetas-pretensadas-¿por-qué-vienen-de-distintas-alturas?",
            id:11
          },
          {
            oldPath: "/blogs/102/como-apuntalar-viguetas-sin-cometer-errores",
            newPath: "/noticias/¿cómo-apuntalar-las-viguetas-correctamente?",
            id:12
          },
          {
            oldPath: "/blogs/91/queres-saber-mas-sobre-vigueta-autoportante",
            newPath: "/noticias/¿querés-saber-más-sobre-la-vigueta-autoportante?",
            id:13
          },
          {
            oldPath: "/blogs/108/como-evitar-fisuras-mamposterias-bloques-hormigon",
            newPath: "/noticias/cómo-evitar-fisuras-en-mamposterías-de-bloques-de-hormigón-",
            id:14
          },
          {
            oldPath: "/blogs/110/se-deben-apuntalar-viguetas-cortas",
            newPath: "/noticias/¿se-deben-apuntalar-viguetas-cortas?",
            id:15
          },
          {
            oldPath: "/blogs/94/como-son-columnas-vigas-bloques-hormigon",
            newPath: "/noticias/¿cómo-son-las-columnas-y-vigas-con-bloques-de-hormigón?",
            id:16
          },
          {
            oldPath: "/blogs/113/bloques-hormigon-ventajas-desventajas",
            newPath: "/tensonews",
            id:17
          },
          {
            oldPath: "/blogs/107/que-son-pavimentos-intertrabados-adoquines",
            newPath: "/noticias/¿qué-son-los-pavimentos-intertrabados-de-adoquines?",
            id:18
          },
          {
            oldPath: "/blogs/99/base-para-adoquines",
            newPath: "/noticias/base-para-los-adoquines",
            id:19
          },
          {
            oldPath: "/blogs/115/que-vigueta",
            newPath: "/noticias/¿qué-es-una-vigueta?-",
            id:20
          },
          {
            oldPath: "/blogs/122/como-hacer-losa-viguetas",
            newPath: "/noticias/¿cómo-hacer-una-losa-de-viguetas?-",
            id:21
          },
          {
            oldPath: "/blogs/124/detalles-constructivos-losas-viguetas",
            newPath: "/noticias/detalles-constructivos-de-las-losas-de-viguetas-",
            id:22
          },
          {
            oldPath: "/blogs/97/conoces-metodo-pared-terminada",
            newPath: "/noticias/¿conoces-el-método-de-pared-terminada?",
            id:23
          },
          {
            oldPath: "/blogs/92/mitos-realidades-mamposteria-bloques-hormigon",
            newPath: "/noticias/mitos-y-realidades-de-la-mampostería-de-bloques-de-hormigón",
            id:24
          },
          {
            oldPath: "/blogs/103/muros-bloques-impermables-resistentes-durables",
            newPath: "/noticias/muros-de-bloques-impermables,-resistentes-y-durables",
            id:25
          },
    ], 

]